import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from '../../../context/AuthContext'
import { ADMIN_FORM_MODULES } from '../../../constants/adminModules'
import { ADMIN_DASHBOARD_PATH } from '../../../constants/adminRoutes'

export default function FormModuleGuard({ module, children }) {
  const { hasModuleAccess } = useAuth()
  const location = useLocation()

  if (!hasModuleAccess(module)) {
    const first = ADMIN_FORM_MODULES.find(({ key }) => hasModuleAccess(key))
    if (first) {
      return <Navigate to={`/cp-login/forms/${first.route}`} replace state={{ from: location }} />
    }
    return <Navigate to={ADMIN_DASHBOARD_PATH} replace />
  }

  return children
}
